const allFlights = [
  { name: "tashkent-istanbul", path: "tashkent-istanbul" },
  { name: "tashkent-moscow", path: "tashkent-moscow" },
  { name: "tashkent-dubai", path: "tashkent-dubai" },
  { name: "tashkent-belarus", path: "tashkent-belarus" },
  { name: "tashkent-almaty", path: "tashkent-almaty" },
  { name: "tashkent-bishkek", path: "tashkent-bishkek" },
  { name: "tashkent-dushanbe", path: "tashkent-dushanbe" },
  { name: "tashkent-beijing", path: "tashkent-beijing" },
  { name: "tashkent-azerbaijan", path: "tashkent-azerbaijan" },
  { name: "tashkent-georgia", path: "tashkent-georgia" },
  { name: "tashkent-saudiarabia", path: "tashkent-saudiarabia" },
  { name: "tashkent-qatar", path: "tashkent-qatar" },
  { name: "tashkent-poland", path: "tashkent-poland" },
  { name: "tashkent-latvia", path: "tashkent-latvia" },
  { name: "tashkent-france", path: "tashkent-france" },
  { name: "tashkent-italy", path: "tashkent-italy" },
  { name: "tashkent-spain", path: "tashkent-spain" },
  { name: "tashkent-uk", path: "tashkent-uk" },
  { name: "tashkent-germany", path: "tashkent-germany" },
  { name: "tashkent-czechia", path: "tashkent-czechia" },
  { name: "tashkent-seoul", path: "tashkent-seoul" },
  { name: "tashkent-pusan", path: "tashkent-pusan" },
  { name: "tashkent-tokyo", path: "tashkent-tokyo" },
  { name: "tashkent-kualalumpur", path: "tashkent-kualalumpur" },
  { name: "tashkent-bangkok", path: "tashkent-bangkok" },
  { name: "tashkent-phuket", path: "tashkent-phuket" },
  { name: "tashkent-danang", path: "tashkent-danang" },
  { name: "tashkent-delhi", path: "tashkent-delhi" },
  { name: "tashkent-denpasar", path: "tashkent-denpasar" },
  { name: "tashkent-mumbai", path: "tashkent-mumbai" },
  { name: "tashkent-mopa", path: "tashkent-mopa" },
  { name: "tashkent-lahore", path: "tashkent-lahore" },
  { name: "tashkent-islamabad", path: "tashkent-islamabad" },
  { name: "tashkent-ankara", path: "tashkent-ankara" },
  { name: "tashkent-trabzon", path: "tashkent-trabzon" },
  { name: "tashkent-saintpetersburg", path: "tashkent-saintpetersburg" },
  { name: "tashkent-novosibirsk", path: "tashkent-novosibirsk" },
  { name: "tashkent-ekaterinburg", path: "tashkent-ekaterinburg" },
  { name: "tashkent-kazan", path: "tashkent-kazan" },
  { name: "tashkent-irkutsk", path: "tashkent-irkutsk" },
  { name: "tashkent-grozny", path: "tashkent-grozny" },
  { name: "tashkent-samara", path: "tashkent-samara" },
  { name: "tashkent-krasnoyarsk", path: "tashkent-krasnoyarsk" },
  { name: "tashkent-novgorod", path: "tashkent-novgorod" },
  { name: "tashkent-kuwaitcity", path: "tashkent-kuwaitcity" },
  { name: "tashkent-tbilisi", path: "tashkent-tbilisi" },
  { name: "tashkent-batumi", path: "tashkent-batumi" },
  { name: "tashkent-warsaw", path: "tashkent-warsaw" },
  { name: "tashkent-riga", path: "tashkent-riga" },
  { name: "tashkent-sharmelsheikh", path: "tashkent-sharmelsheikh" },
  { name: "tashkent-jeddah", path: "tashkent-jeddah" },
  { name: "tashkent-medina", path: "tashkent-medina" },
  { name: "tashkent-osh", path: "tashkent-osh" },
  { name: "tashkent-issyk-kul", path: "tashkent-issyk-kul" },
  { name: "tashkent-ashgabat", path: "tashkent-ashgabat" },
  { name: "tashkent-sharjah", path: "tashkent-sharjah" },
  { name: "tashkent-sanya", path: "tashkent-sanya" },
  { name: "tashkent-hangzhou", path: "tashkent-hangzhou" },
  { name: "tashkent-xian", path: "tashkent-xian" },
  { name: "tashkent-chengdu", path: "tashkent-chengdu" },
  { name: "tashkent-urumqi", path: "tashkent-urumqi" },
  { name: "tashkent-busan", path: "tashkent-busan" },
];

const importFlightData = async fileName => {
  try {
    const flightData = await import(`./flightsInfoJsons/${fileName}.json`);
    return flightData?.default || null;
  } catch (error) {
    console.error(`Error importing flight data from ${fileName}:`, error);
    return null;
  }
};

export const getAllFlights = async () => {
  const flights = [];

  for (const flight of allFlights) {
    const flightData = await importFlightData(flight.path);

    if (flightData) {
      flights.push(flightData);
    }
  }

  return flights;
};

export const getFlightsMiniInfo = async (limit = 0, isRandom = true) => {
  let processedFlights = [...allFlights];

  if (isRandom) {
    processedFlights = processedFlights.sort(() => Math.random() - 0.5);
  }

  if (limit > 0) {
    processedFlights = processedFlights.slice(0, limit);
  }

  const result = [];

  for (const flight of processedFlights) {
    if (!flight.path) {
      console.warn(`Flight missing path:`, flight);
      continue;
    }

    const flightData = await importFlightData(flight.path);

    if (flightData?.key && flightData?.name) {
      result.push({
        key: flightData.key,
        name: flightData.name,
      });
    }
  }

  return result;
};
